import { render, staticRenderFns } from "./fourGrids2.vue?vue&type=template&id=4b95ee7a&scoped=true&"
import script from "./fourGrids2.vue?vue&type=script&lang=js&"
export * from "./fourGrids2.vue?vue&type=script&lang=js&"
import style0 from "./fourGrids2.vue?vue&type=style&index=0&id=4b95ee7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95ee7a",
  null
  
)

export default component.exports